import React from "react";
import PropTypes from "prop-types";

import { CareersList } from "./components/CareersList";

export function Careers({ careers }) {
  return careers.length ? (
    <CareersList careers={careers} />
  ) : (
    <p data-enzyme="no-openings">There are currently no openings.</p>
  );
}

Careers.propTypes = {
  careers: PropTypes.array,
};
